import { render, staticRenderFns } from "./TermsConditionsForm.vue?vue&type=template&id=3b673968&v-if=configuration"
import script from "./TermsConditionsForm.vue?vue&type=script&lang=js"
export * from "./TermsConditionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports